<template>
  <div class="container">
    <img src="../../assets/h5Bg.png" class="bg" @click="openMiniApp" />
  </div>
</template>

<script>
import HomeAPI from "../../api/home.js";
export default {
  data() {
    return {
      url: "",
    };
  },

  async mounted() {
    const query = this.$route.query;
    let data = {
      path: query.path,
      query: query.query,
    };
    const result = await HomeAPI.GetMiniAppUrl(data);
    this.url = result.msg;
    location.href = result.msg;
    console.log("GetMiniAppUrl", query);
  },
  methods: {
    async openMiniApp() {
      const query = this.$route.query;
      let data = {
        path: query.path,
        query: query.query,
      };
      const result = await HomeAPI.GetMiniAppUrl(data);
      this.url = result.msg;
      location.href = result.msg;
      console.log("GetMiniAppUrl", query);
    },
  },
};
</script>

<style lang="less" scoped>
.bg {
  width: 100vw;
}
</style>
